import { Box, Button, Typography } from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react";
import NavigationNotFound from "../../assets/images/navigation_not_found_1x.png";
import { Colors } from "../../styles/constant";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux-store/CustomReduxHooks";
import { triggerGenerateSSOOld } from "../../features/Feature_SSO/Sso_Slice";
import {
  T_ValidateSSOOldRes,
  TriggerGenerateSSO_OLD,
} from "../../features/Feature_SSO/Sso_Types";
import {
  OneLoginLobCode,
  OneLoginRedirectUrl,
  REACT_APP_URL,
} from "../../utils/constants";
import { useDispatch } from "react-redux";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import { updateLoadingState } from "../../features/Feature_Loading/Loading_Slice";
import CustomLink from "../../components/CustomLink/CustomLink";
import { R_HomeRoutes } from "../../utils/Routes";

const UnableToNavigate: FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [emailInfo, setEmailInfo] = useState<string>("");
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const ssoSlice = useAppSelector(
    (state) => state.SsoSlice.ssoData as T_ValidateSSOOldRes,
  );
  const doReverseSSO = useCallback(() => {
    dispatch(updateLoadingState(true));
    dispatch(
      triggerGenerateSSOOld({
        triggerGenerateSSO_Old:
          (ssoSlice as TriggerGenerateSSO_OLD).triggerGenerateSSO_Old || true,
        ciiNo: ssoSlice.ciiNo,
        functionality: "D",
        mobileNo: ssoSlice.mobileNo || "",
        lobClientId: ssoSlice.lobClientId,
        channel: E_ChannelOptions.CSAPP,
        sourceLobId: "26",
        destinationLobId: OneLoginLobCode,
        callbackUrl: `${REACT_APP_URL}/login`,
        redirectionUrl: OneLoginRedirectUrl,
        appVersion: "1",
        panNumber: ssoSlice.panNumber || "",
        customerFullName: ssoSlice.customerFullName || "",
        customerDob: ssoSlice.customerDob || "",
        emailId: ssoSlice.emailId || "",
        osVersion: "Windows",
        imei: "1231312",
        deviceId: "131312",
        userAgent: navigator.userAgent,
        clientIpAddress: "",
        udp: "",
        udp2: "",
        udp3: "",
        udp4: "",
        udp5: "",
        udp6: "",
        udp7: "",
        udp8: "",
        udp9: "",
        udp10: "",
      } as TriggerGenerateSSO_OLD),
    );
  }, [ssoSlice]);

  const gotoHomepage = useCallback(() => {
    if (csAppSlice.channel === E_ChannelOptions.ONE_ABC) {
      doReverseSSO();
    } else {
      navigate(R_HomeRoutes.home, { replace: true });
    }
  }, [csAppSlice.channel]);

  const fetchConfigDataDetails = useAppSelector(
    (state) => state.GeneralAppElementsSlice?.masterData?.supportDataList || [],
  );
  useEffect(() => {
    const emailUsItem = fetchConfigDataDetails.find(
      (item) => item.optionType === "Email Us",
    );
    if (emailUsItem) {
      setEmailInfo(emailUsItem.contactInfo);
    }
  }, [fetchConfigDataDetails]);
  const handleClick = () => {
    // window.location.href = `mailto:${emailInfo}?subject=Inquiry`;
    window.location.href = `mailto:${emailInfo}?subject=Service%20Platform%20Inquiry`;
  };
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      marginLeft={"32px"}
      marginRight={"32px"}
      height="100vh"
    >
      <img src={NavigationNotFound} height={"196px"} width={"196px"} />
      <div
        style={{ marginTop: "2rem", marginBlock: "2rem", textAlign: "center" }}
      >
        <Typography variant="h3" color={Colors.textblack}>
          Unable to navigate
        </Typography>
        <Typography variant="subtitle2" sx={{ marginTop: "1rem" }}>
          We are facing some technical issue. Please try again after some time 
        </Typography>
        <Typography
          variant="h5"
          color={"#252525"}
          sx={{ marginTop: "1.25rem" }}
        >
          OR
        </Typography>
        <Typography variant="subtitle2" sx={{ marginTop: "1.25rem" }}>
          In case of any concern, you can write to us on{" "}
          <span style={{ color: Colors.red }}>
            care.digital@adityabirlacapital.com
          </span>{" "}
          via your registered email ID
        </Typography>
      </div>

      <Button
        variant="contained"
        fullWidth
        onClick={handleClick}
        sx={{ marginBottom: "1rem" }}
      >
        Email Now
      </Button>
      <CustomLink
        title="Go back to homepage"
        onClick={gotoHomepage}
        titleSize={".75rem"}
        imgWidth={".625rem"}
      />
    </Box>
  );
};
export default UnableToNavigate;
